// extracted by css-extract-rspack-plugin
export default {"CompareItems":"CompareItems-module__CompareItems___dGg5W","compareItems":"CompareItems-module__CompareItems___dGg5W"};